// extracted by mini-css-extract-plugin
module.exports = {"section_header":"styles_section_header__Pt__x","title":"styles_title__n0dbw"};